
const productUnits = {
  quantity: "عدد",
  kilogram: "kg",
  liter: "L",
  milliLiter: "ml",
  gram: "g",
  ton: "ton",
  cc: "cc",
  meter: "m",
  squareMeter: "m2",
  cubicMeter: "m3",
  feet: "ft",
  inche: "in",
  squareInche: "m2",
  squareFeet: "m2",
  dozen: "جین",
  hour: "ساعت",
  minute: "دقیقه"
}

export default productUnits